module.exports = __webpack_public_path__ + "img/thumbnail_Babirusa_f_normal.c3db3854.png";